var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"flex items-center justify-center text-white-1 text-xs font-bold",class:!_vm.isRecording && !_vm.isPaused && 'hidden'},[_vm._v(" "+_vm._s(_vm.label)+" "),(!_vm.isPaused)?_c('DotSVG',{staticClass:"fill-accent ml-1 w-4 h-4"}):_c('PauseSVG',{staticClass:"fill-accent ml-1 w-4 h-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }